import { Options, OptionsQuery } from '@shared/ui/components/Select';
import { getUsers } from '@shared/users/endpoints/getUsers';

export function getUserOptions({ search, value }: OptionsQuery): Promise<Options> {
  return getUsers({ filter: { name: search, id: value } }).then(({ data }) =>
    data.map((user) => ({
      label: user.fullName,
      value: user.id,
    }))
  );
}
